import {RsnButton, RsnDialog, RsnTextButton} from '@raison/ui-kit';
import React from 'react';
import {useDerived} from '../../lib/useDerivedAtom';
import {canceledTrTxIds$} from '../../model/TrTxIdsRegistry';
import {TrTxId} from '../../model/TrTx';

export function AreYouSureCancelDialog({trtId, onApprove}: {trtId: TrTxId; onApprove: () => void}) {
    const {onClose} = RsnDialog.useControls();
    const cancelling = useDerived(canceledTrTxIds$, c => c.has(trtId));

    const t = {
        AreYouSure: 'Are you sure you want to cancel the transaction?',
        Warning: "You'll need to re-enter all the information to create a new transaction.",
        No: "No, I don't want to cancel",
        Yes: 'Yes, I want to cancel',
        RequestSent: 'Cancellation request sent',
        FewChecks: 'After a few small checks, your transaction will be cancelled.',
        IGotIt: 'I got it',
    };
    return cancelling ? (
        <RsnDialog.Window>
            <RsnDialog.CenteredHeader>{t.RequestSent}</RsnDialog.CenteredHeader>
            <RsnDialog.Body>{t.FewChecks}</RsnDialog.Body>
            <RsnDialog.Footer column>
                <RsnButton key='close' intent='secondary' onClick={onClose}>
                    {t.IGotIt}
                </RsnButton>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    ) : (
        <RsnDialog.Window>
            <RsnDialog.CenteredHeader>{t.AreYouSure}</RsnDialog.CenteredHeader>
            <RsnDialog.Body>{t.Warning}</RsnDialog.Body>
            <RsnDialog.Footer column>
                <RsnTextButton.Block onClick={onApprove}>{t.Yes}</RsnTextButton.Block>
                <RsnButton key='close' intent='primary' onClick={onClose}>
                    {t.No}
                </RsnButton>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}
